import React from 'react';
import { useSetWidgetAttribute } from '../hooks/useSetWidgetAttribute';
import CollapsibleSection from '../../common/CollapsibleSection';
import styles from '../gen2_widgets/base/CommonSettings'
import { useSelector } from 'react-redux';
import Select from '../../common/Select.jsx';

const HORIZONTAL_OPTIONS = [
  {
    value: 'start',
    label: I18n.t('left')
  },
  {
    value: 'center',
    label: I18n.t('middle')
  },
  {
    value: 'end',
    label: I18n.t('right')
  }
]

const VERTICAL_OPTIONS = [
  {
    value: 'start',
    label: I18n.t('top')
  },
  {
    value: 'center',
    label: I18n.t('middle')
  },
  {
    value: 'end',
    label: I18n.t('bottom')
  }
]

// Assume that container is flex-box flex-direction column
function AlignmentSettings({widgetId}){
  const setAttribute = useSetWidgetAttribute(widgetId);
  const alignment = useSelector(state => state.dashboard.widgets[widgetId]?.settings?.alignment) || {};

  return (
    <CollapsibleSection title={I18n.t('alignment')}>
      <div className={`${styles['settings-option']} mb-1`}>
        <label className='w-100'>{I18n.t('horizontal')}</label>
        <Select
          options={HORIZONTAL_OPTIONS}
          value={alignment.horizontal || 'start'}
          onChange={(v) => setAttribute('settings.alignment.horizontal', v)}
        />
      </div>
      <div className={styles['settings-option']}>
        <label className='w-100'>{I18n.t('vertical')}</label>
        <Select
          options={VERTICAL_OPTIONS}
          value={alignment.vertical || 'start'}
          onChange={(v) => setAttribute('settings.alignment.vertical', v)}
        />
      </div>
    </CollapsibleSection>
  )
}

export default AlignmentSettings;
